export default [  
  {
    path: '/clerks',
    name: 'clerks',
    component: () => import('@/views/modules/clerks/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Clerks List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Clerks' }
      ]
    },
    children:[
      {
        path: '/clerks/create',
        name: 'clerks-create',
        component: () => import('@/views/modules/clerks/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Clerk Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Clerks', link: '/clerks' },
            { text: 'Create' }
          ]
        }
      },
      {
        path: '/clerks/:id/edit',
        props: true,
        name: 'clerks-edit',
        component: () => import('@/views/modules/clerks/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Clerks Edit',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Clerk',  to: { name: "clerks-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
     
    
    ]
  },
 
]